import {
    LOGIN,
    STATE,
    CITY,
    PROFILE_INFO,
    SET_PROFILE,
    GET_SLIDER,
    GET_APP,
    // GET_ALLADDRESS,
    // GET_SELLER,
    // SECTOR,
    // GET_SEARCH,
    // SET_PRO,
    SET_TOKEN,
    LOGOUT,
    ADD_TICKET,
    GET_TICKET,
    GET_WALLET,
    GET_COUNT,
    GET_INIT_ORDER,
    SET_PUSH_TOK
    // SET_QUN
} from "../action/userLogin";






const initialState = {

    mobile: null,

}




export default (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return { ...state, data: action.data };
        case STATE:
            return { ...state, data: action.data };
        case CITY:
            return { ...state, data: action.data };
        case PROFILE_INFO:
            return { ...state, data: action.data };
        case SET_PROFILE:
            return { ...state, data: action.data };
        case GET_SLIDER:
            return { ...state, data: action.data };
        case GET_APP:
            return { ...state, data: action.data };
        case SET_TOKEN:
            return { ...state, datatoken: action.data };
        case ADD_TICKET:
            return { ...state, data: action.data };
        case GET_TICKET:
            return { ...state, data: action.data };
        case GET_WALLET:
            return { ...state, data: action.data };
        case GET_COUNT:
            return { ...state, data: action.data };
        case GET_INIT_ORDER:
            return { ...state, data: action.data };
            case SET_PUSH_TOK:
            return { ...state, data: action.data };
        case LOGOUT:
            return initialState;


        default:
            return state;
    }
}
